<template>
  <div style="width: 100%">
    <v-overlay
      :value="
        $wait.is('loading webshop getProducts') ||
        $wait.is('loading webshop GetCampaignProducts') ||
        $wait.is('loading webshop getProducts and Campaign')
      "
      absolute
    />
    <div
      v-if="
        !$wait.is('loading webshop getProducts') &&
        !$wait.is('loading webshop GetCampaignProducts') &&
        !$wait.is('loading webshop getProducts and Campaign')
      "
    >
      <v-row no-gutters>
        <v-col
          v-for="(product, index) in products"
          :key="product.id"
          class="px-1"
          :class="{
            'py-0': $vuetify.breakpoint.xs,
            'py-2': !$vuetify.breakpoint.xs,
          }"
          cols="6"
          lg="4"
          md="4"
          sm="6"
          xl="3"
          xs="6"
        >
          <webshop-product-item
            :class="{
              'pb-3': $vuetify.breakpoint.smAndUp,
              'pl-0 pr-0 pt-0 pb-4 ma-0 pa-0': $vuetify.breakpoint.xs,
              'text-center': $vuetify.breakpoint.smAndUp,
            }"
            style="height: 100%"
            :index="index"
            :product="product"
            :campaign="campaign"
            :isCampaignView="$route.name === 'webshopCampaignProducts'"
            class="px-2"
          />
        </v-col>
      </v-row>
      <v-container>
        <v-pagination
          v-if="paginationPageCount > 1 && products.length"
          :length="paginationPageCount"
          :total-visible="$vuetify.breakpoint.smAndUp ? 10 : 5"
          :value="currentPage"
          @input="changePage"
        ></v-pagination>
        <div
          v-if="!products.length"
          class="text-center fill-height"
          style="width: 100%"
        >
          Ingen produkter
        </div>
      </v-container>
    </div>
    <div v-else class="text-center mt-8" style="width: 100%">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import WebshopProductItem from "./WebshopProductItem";
import { mapWaitingActions } from "vue-wait";
import campaign from "@/services/campaign";

export default {
  components: {
    WebshopProductItem,
  },
  mixins: [webshopMixins],
  data() {
    return {
      campaign: null,
      prevBoughtProducts: [],
    };
  },
  computed: {
    allBrands() {
      return this.$store.getters["webshop/get"]("brands");
    },

    itemsPerPage() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
          return 60;
        case "lg":
          return 52;
        case "md":
          return 42;
        case "sm":
          return 42;
        case "xs":
          return 20;
        default:
          return 50;
      }
    },

    paginationPageCount() {
      return this.$store.getters["webshop/get"]("totalPagesPagination");
    },

    currentPage() {
      return parseInt(this.$route.query.page || 1);
    },

    boughtProducts() {
      return this.prevBoughtProducts;
    },
  },
  methods: {
    ...mapWaitingActions("webshop", {
      getProducts: "loading webshop getProducts",
      GetCampaignProducts: "loading webshop GetCampaignProducts",
    }),

    ...mapWaitingActions("campaigns", {
      fetchById: "loading webshop getProducts and Campaign",
    }),

    changePage(v) {
      this.$router.push({ query: { ...this.$route.query, page: v } });
    },
  },
  watch: {
    "$vuetify.breakpoint.name"() {
      if (this.$route.name != "webshopCampaignProducts") {
        this.getProducts({
          ...this.$route.query,
          chainId: this.currentChainId,
          itemsPerPage: this.itemsPerPage,
        });
      }
    },
    currentPage: {
      handler() {},
      immediate: true,
    },
    $route: {
      async handler(val) {
        if (val.name === "webshopCampaignProducts") {
          // if (this.campaigns.length) {
          //   this.campaign = this.campaigns.find((b) => b.campaignId == val.params.campaignId);

          // } else {
          this.$store.dispatch(
            "campaigns/getCampaingsByFilter",
            this.currentChainId
          );

          if (val.query.brand && !Array.isArray(val.query.brand))
            val.query.brand = [val.query.brand];
          if (val.query.serie && !Array.isArray(val.query.serie))
            val.query.serie = [val.query.serie];
          if (val.query.site && !Array.isArray(val.query.site))
            val.query.site = [val.query.site];
          if (val.query.mCategory && !Array.isArray(val.query.mCategory))
            val.query.mCategory = [val.query.mCategory];
          if (val.query.category && !Array.isArray(val.query.category))
            val.query.category = [val.query.category];

          await this.fetchById({
            campaignId: val.params.campaignId,
            chainId: this.currentChainId,
            fetchProducts: {
              ...val.query,
              tCategory: this.categories.find(
                (c) => this.$route.params.categoryFirst === c.urlSafeTitle
              )?.title,
              chainId: this.currentChainId,
              itemsPerPage: this.itemsPerPage,
              avoidCache: true,
            },
          });
          // }
          this.campaign = this.$store.getters["campaigns/getCampaign"];
          this.$store.dispatch("webshop/set", {
            key: "products",
            value: this.campaign.products,
          });
          this.campaign.products = this.products;
          this.$store.dispatch("campaigns/set", {
            key: "campaign",
            value: this.campaign,
          });
        } else {
          this.campaign = null;
          if (val.query.brand && !Array.isArray(val.query.brand))
            val.query.brand = [val.query.brand];
          if (val.query.serie && !Array.isArray(val.query.serie))
            val.query.serie = [val.query.serie];
          if (val.query.site && !Array.isArray(val.query.site))
            val.query.site = [val.query.site];
          if (val.query.mCategory && !Array.isArray(val.query.mCategory))
            val.query.mCategory = [val.query.mCategory];
          if (val.query.category && !Array.isArray(val.query.category))
            val.query.category = [val.query.category];
          await this.getProducts({
            ...val.query,
            tCategory: this.categories.find(
              (c) => this.$route.params.categoryFirst === c.urlSafeTitle
            )?.title,
            chainId: this.currentChainId,
            itemsPerPage: this.itemsPerPage,
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style></style>
